module.exports = __webpack_public_path__ + "static/media/Entertainment Industry Foundation.da3dc4cf.png";